
export const server_name = "dadmin-server";
export const server_name_ws = "EbkqCVR3AbRgLnuu1GgpFsMwpNLYMD2xRHU";